import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { IOperatorVideoRenditionsVm } from '../operator-video-renditions-vm.model';

@Injectable({ providedIn: 'root' })
export class OperatorVideoRenditionsService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OperatorVideoRenditions`;
  }

  get(): Observable<IOperatorVideoRenditionsVm> {
    const headers = this.createHeaders();
    return this.http.get<IOperatorVideoRenditionsVm>(this.baseUrl, { headers });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
